export const obtenerValorReserva = (numNoches, habitacion)=>{

    let valor = parseInt(habitacion.tarifa)


    return valor * numNoches

}